import { render, staticRenderFns } from "./editAssetStatus.vue?vue&type=template&id=08ed297c&scoped=true"
import script from "./editAssetStatus.vue?vue&type=script&lang=js"
export * from "./editAssetStatus.vue?vue&type=script&lang=js"
import style0 from "./editAssetStatus.vue?vue&type=style&index=0&id=08ed297c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ed297c",
  null
  
)

export default component.exports